import './ImageEditorUnsavedChangesModal.scss';

const ImageEditorUnsavedChangesModal = (props) => {
  return (
    <div className="image-editor-unsaved-changes-modal">
      <div
        className="overlay"
        onClick={props.Close}
      />
      <div className="modal">
        <h1>Unsaved Changes</h1>
        <p>
          You have unsaved changes. Do you want to save your edits before closing the image editor?
        </p>
        <section className='action'>
          <span onClick={props.DisacardAndLeave}>
            Exit
          </span>

          <div className='right-action'>
            <span onClick={props.Close}>
              Cancel
            </span>
            <span onClick={props.Save}>Save</span>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ImageEditorUnsavedChangesModal;
